import React from "react";
import GAContentModerationContainer from "../../modules/GAContentModeration/containers/GAContentModerationContainer/GAContentModerationContainer";

const GAContentModeration = () => {
  return <GAContentModerationContainer />;
};

export default GAContentModeration;
